import React from "react";
import { useNavigate } from "react-router-dom";

export default function Sidebar({ active, onChange, username }) {
    const navigate = useNavigate();

    const handleLogout = () => {
        console.log("LOGOUT CLICKED");
        localStorage.removeItem("user");
        navigate("/"); // No page refresh
    };

    const goHome = () => {
        navigate("/"); // No page refresh
    };

    return (
        <div
            className="d-flex flex-column"
            style={{
                width: "240px",
                minHeight: "100vh",
                background: "#ffffff",
                borderRight: "1px solid #e5e7eb",
            }}
        >

            {/* Inline CSS */}
            <style>
                {`
                .side-user {
                    padding: 20px;
                    border-bottom: 1px solid #f1f1f1;
                }

                .side-name {
                    font-size: 16px;
                    font-weight: 600;
                    color: #1f2937;
                }

                .side-role {
                    font-size: 13px;
                    color: #6b7280;
                }

                .nav-btn {
                    width: 100%;
                    text-align: left;
                    border: none;
                    background: transparent;
                    padding: 10px 16px;
                    border-radius: 6px;
                    font-size: 15px;
                    color: #374151;
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    transition: 0.15s;
                    border-left: 3px solid transparent;
                }

                .nav-btn:hover {
                    background: #f8f9fa;
                }

                .nav-btn.active {
                    border-left: 3px solid #2563eb;
                    background: #f0f4ff;
                    font-weight: 600;
                }

                .nav-icon {
                    font-size: 1.1rem;
                }
                `}
            </style>

            {/* USER BOX */}
            <div className="side-user d-flex align-items-center gap-3">
                <img
                    src={`https://ui-avatars.com/api/?name=${encodeURIComponent(
                        username && username.trim() !== "" ? username : "Admin"
                    )}&background=2563EB&color=fff`}
                    alt="user"
                    width="42"
                    height="42"
                    className="rounded-circle"
                />
                <div>
                    <div className="side-name">
                        {username && username.trim() !== "" ? username : "Admin"}
                    </div>
                    <div className="side-role">Administrator</div>
                </div>
            </div>

            {/* NAVIGATION */}
            <div className="p-3">
                <button
                    className={`nav-btn ${active === "UserProfile" ? "active" : ""}`}
                    onClick={() => onChange("UserProfile")}
                >
                    <i className="bi bi-person nav-icon"></i>
                    Profile
                </button>

                <button
                    className={`nav-btn ${active === "MyListings" ? "active" : ""}`}
                    onClick={() => onChange("MyListings")}
                >
                    <i className="bi bi-building nav-icon"></i>
                    Listed Business
                </button>


            </div>

            {/* BOTTOM BUTTONS */}
            <div className="mt-auto p-3">

                {/* Back Home Button */}
                <button
                    className="btn btn-warning w-100 mb-2 d-flex justify-content-center gap-2"
                    onClick={goHome}
                >
                    <i className="bi bi-arrow-left"></i>
                    Back Home
                </button>

                {/* Logout Button */}
                <button
                    className="btn btn-outline-danger w-100 d-flex justify-content-center gap-2"
                    onClick={handleLogout}
                >
                    <i className="bi bi-box-arrow-right"></i>
                    Logout
                </button>

            </div>
        </div>
    );
}
